var SearchComponent = $.extend({/* SearchComponent */}, BaseComponent, {

	componentSelector: '.search',

	init: function() {
		device.mobile() ? this.initSearchTool() : this.initSearchTool();
	},

	initSearchTool: function() {

		$(this.componentSelector).each((function (index, element) {

			$(element).find('.standoff').addClass('active');

			$(element).find('.search-trigger').click((function(event) {
				if ($(event.currentTarget).find('.standoff').hasClass('active')) {
					$(event.currentTarget).parents('.search').addClass('active');
					$(event.currentTarget).find('.standoff').removeClass('active');
					$(event.currentTarget).find('.standon').addClass('active');
					$(event.currentTarget).parent('.search-header').next('.search-form').show();
					$(event.currentTarget).siblings('.dismiss-search-form').addClass('active');
				}
				else if ($(event.currentTarget).find('.standon').hasClass('active')) {
					$(event.currentTarget).parents('.search').removeClass('active');
					$(event.currentTarget).find('.standon').removeClass('active');
					$(event.currentTarget).find('.standoff').addClass('active');
					$(event.currentTarget).parent('.search-header').next('.search-form').hide();
					$(event.currentTarget).siblings('.dismiss-search-form').removeClass('active');
				}
			}).bind(this));

		}).bind(this));
	},

	initMobileSearchTool: function() {

		$(this.componentSelector).each((function (index, element) {

			//$(element).find('.standon').addClass('active');
			//$(element).find('.search-form').show();

		}).bind(this));
	}	
})